export default "__VITE_ASSET__CRTEVXZV__"